module.exports = __webpack_public_path__ + "img/skype.05786daf.svg";